import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { documentationActions } from '../../actions/constant';
import templateService from 'src/services/apiServices/document-management/template-service';
const {
  REQUEST_GET_ALL_CODES_ICD,
  SUCCESS_GET_ALL_CODES_ICD,
  FAILURE_GET_ALL_CODES_ICD,
  LOADING_GET_ALL_CODES_ICD,
} = documentationActions;

function* getAllICDCodes(action: any): SagaReturnType<any> {
  try {
    yield put({ type: LOADING_GET_ALL_CODES_ICD });
    const response = yield call(
      templateService.getCPTorICDcodes,
      action.payload,
      action.patientUuid
    );
    if (response?.status === 200) {
      yield put({ type: SUCCESS_GET_ALL_CODES_ICD, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_GET_ALL_CODES_ICD, payload: error });
  }
}

function* getAllICDCodesSaga() {
  yield takeEvery(REQUEST_GET_ALL_CODES_ICD, getAllICDCodes);
}

export default getAllICDCodesSaga;
